import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { action } from 'mobx';
import { propertyDecorator } from 'decorating';
import { setterName } from '../utils';
export default propertyDecorator(function (target, prop, desc) {
  var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : setterName(prop, 'toggle');
  var fnDesc = action.bound(target, name, {
    value: function value() {
      this[prop] = !this[prop];
    }
  });
  Object.defineProperty(target, name, fnDesc);
  return desc && _objectSpread({}, desc, {
    configurable: true
  });
});